import { default as axiosDefault } from "axios";
import { toastr } from "react-redux-toastr";
import { Async } from "react-select-v2";
import { axios } from "services/axios";
import Service from "../../service";

const FinanceService = {
  // get account names
  getACcountNames: async (token, search, archive = "", page = 1, size = 20) => {
    try {
      return await Service.get(
        `/accounts/account?page=${page}&size=${size}&search=${search === undefined ? "" : search
        }${archive ? `&archive=${archive}` : ""}`,
        token
      );
    } catch (error) {
      throw error;
    }
  },

  getACcountNamesForMerge: async (
    token,
    search,
    archive = "",

    page = 1,
    size = 20
  ) => {
    try {
      return await Service.get(
        `/accounts/account/merge/accounts?page=${page}&size=${size}&search=${search === undefined ? "" : search
        }${archive ? `&archive=${archive}` : ""}`,
        token
      );
    } catch (error) {
      throw error;
    }
  },

  getACcountNamesForApplayLink: async (
    token,
    skipAccountId,
    search,
    page = 1,
    size = 20
  ) => {
    try {
      return await Service.get(

        `/accounts/account?page=${page}&size=${size}&skipAccount=${skipAccountId}&search=${search === undefined ? "" : search
        }`,
        token
      );
    } catch (error) {
      throw error;
    }
  },

  //update Payment information

  updatePayemntInfo: async (data, token) => {
    try {
      return await Service.update({
        url: `finance/v1/payment/update-payment`,
        data,
        token,
      });
    } catch (error) {
      throw error;
    }
  },

  // create new deposit
  createNewDeposit: async (data, token) => {
    try {
      return await Service.post({
        url: `finance/v1/deposit/synce`,
        data,
        token,
      });
    } catch (error) {
      throw error;
    }
  },
  // Get Qucikbooks for deposits
  GetDepositQuickbooks: (token) => {
    try {
      return Service.get(`finance/v1/quickBook/authUri`, token);
    } catch (err) {
      throw err;
    }
  },

  // Create transaction
  createTransaction: async (data, token) => {
    try {
      return await Service.post({ url: `finance/v1/transaction`, data, token });
    } catch (error) {
      throw error;
    }
  },
  // Create batchBillingTransaction
  createBatchBillingTransaction: async (data, token) => {
    try {
      return await Service.post({
        url: `finance/v1/batchBilling`,
        data,
        token,
      });
    } catch (error) {
      throw error;
    }
  },
  //pay all selected charges
  payAllSelectedCharges: async (data, token) => {
    try {
      return await Service.post({
        url: `finance/v1/payment/pay-all`,
        data,
        token,
      });
    } catch (error) {
      throw error;
    }
  },

  //
  verifyAch: async (data, token) => {
    try {
      return await Service.update({
        url: `finance/v1/payment/verify-ach`,
        data,
        token,
      });
    } catch (error) {
      throw error;
    }
  },

  updateTransaction: async (data, token) => {
    try {
      return await Service.update({
        url: `finance/v1/transaction`,
        data: data.payload,
        token,
      });
    } catch (error) {
      throw error;
    }
  },
  //
  markSynced: async (data, token) => {
    try {
      return await Service.update({
        url: `finance/v1/deposit/mark-synced/${data}`,
        token,
      });
    } catch (error) {
      throw error;
    }
  },

  getTransactionById: async (token, id) => {
    try {
      return await Service.get(`finance/v1/transaction/transaction/${id}`, token);
    } catch (err) {
      throw err;
    }
  },

  //delete transaction

  deleteTransaction: (row, token, chargeId = "") => {
    try {
      return Service.remove({
        url: `finance/v1/transaction/transaction/${row?._id ?? row}${chargeId ? `?chargeId=${chargeId}` : ""
          }`,
        token,
      });
    } catch (err) {
      throw err;
    }
  },

  // get all transactions
  getAllTransactions: async (
    token,
    currentPage = 1,
    items_per_page = 10,
    body = null
  ) => {
    try {
      return await Service.post({
        url: `finance/v1/transaction/all?current_page=${currentPage}&items_per_page=${items_per_page}`,
        token,
        data: body,
      });
    } catch (error) {
      throw error;
    }
  },

  // get all transactions enhancement
  getAllTransactionsEnhance: async (
    token,
    currentPage = 1,
    items_per_page = 10,
    body = null
  ) => {
    try {
      return await Service.post({
        url: `finance/v1/transaction/allData?current_page=${currentPage}&items_per_page=${items_per_page}`,
        token,
        data: body,
      });
    } catch (error) {
      throw error;
    }
  },
  getTransactionSummary: async (token, body = null) => {
    try {
      return await Service.post({
        url: `finance/v1/transaction/summary`,
        token,
        data: body,
      });
    } catch (error) {
      throw error;
    }
  },
  // get export transactions enhancement
  getExportTransactionsEnhance: async (token, body = null) => {
    try {
      return await Service.post({
        url: `finance/v1/transaction/export`,
        token,
        data: body,
      });
    } catch (error) {
      throw error;
    }
  },

  // get count for transactions
  getTransactionsCount: async (
    token,
    currentPage = 1,
    items_per_page = 10,
    body = null
  ) => {
    try {
      return await Service.post({
        url: `finance/v1/transaction/allCount?current_page=${currentPage}&items_per_page=${items_per_page}`,
        token,
        data: body,
      });
    } catch (error) {
      throw error;
    }
  },

  //getpaymentsfordeposits
  getPaymentTransactionsForDeposit: async (
    token,
    currentPage = 1,
    items_per_page = 10,
    body = null
  ) => {
    try {
      return await Service.post({
        url: `finance/v1/deposit/payments?current_page=${currentPage}&items_per_page=${items_per_page}`,
        token,
        data: body,
      });
    } catch (error) {
      throw error;
    }
  },

  //getpaymentsfordeposits enhancement
  getPaymentTransactionsForDepositEnhance: async (
    token,
    currentPage = 1,
    items_per_page = 10,
    body = null
  ) => {
    try {
      return await Service.post({
        url: `finance/v1/deposit/paymentsData?current_page=${currentPage}&items_per_page=${items_per_page}`,
        token,
        data: body,
      });
    } catch (error) {
      throw error;
    }
  },

  //getpaymentsfordeposits count
  getPaymentTransactionsForDepositCount: async (
    token,
    currentPage = 1,
    items_per_page = 10,
    body = null
  ) => {
    try {
      return await Service.post({
        url: `finance/v1/deposit/paymentsCount?current_page=${currentPage}&items_per_page=${items_per_page}`,
        token,
        data: body,
      });
    } catch (error) {
      throw error;
    }
  },

  //Get finance Amount
  getAmountByAccountId: (token, id) => {
    try {
      return Service.get(
        `finance/v1/transaction/accounts?accountId=${id}`,
        token
      );
    } catch (err) {
      throw err;
    }
  },

  // Get transaction by ID
  getTransactionsByID: async (
    token,
    currentPage = 1,
    items_per_page = 10,
    body = null
  ) => {
    try {
      return await Service.post({
        url: `finance/v1/transaction/all?current_page=${currentPage}&items_per_page=${items_per_page}`,
        token,
        data: body,
      });
    } catch (error) {
      throw error;
    }
  },
  // get all documents
  getAllDocuments: async (
    token,
    currentPage = 1,
    items_per_page = 10,
    body = null
  ) => {
    try {
      return await Service.post({
        url: `finance/v1/document/list?current_page=${currentPage}&items_per_page=${items_per_page}`,
        token,
        data: body,
      });
    } catch (error) {
      throw error;
    }
  },
  // get all batch documents
  getBatchDocuments: async (
    token,
    currentPage = 1,
    items_per_page = 10,
    body = null
  ) => {
    try {
      return await Service.post({
        url: `finance/v1/document/batch/list?current_page=${currentPage}&items_per_page=${items_per_page}`,
        token,
        data: body,
      });
    } catch (error) {
      throw error;
    }
  },
  // set all batch documents
  setBatchDocuments: async (token, body = null) => {
    try {
      return await Service.post({
        url: `finance/v1/document/batch`,
        token,
        data: body,
      });
    } catch (error) {
      throw error;
    }
  },

  // download all batch documents
  downloadBatchDocuments: async (token, body = null) => {
    try {
      return await Service.post({
        url: `finance/v1/document/batch`,
        token,
        data: body,
      });
    } catch (error) {
      throw error;
    }
  },

  // delete batch documents
  deleteBatchDocument: (token, batchId) => {
    try {
      return Service.remove({
        url: `finance/v1/document/batch?id=${batchId}`,
        token,
      });
    } catch (err) {
      throw err;
    }
  },

  // get document list by transaction id
  getDocumentByTransactionId: (token, id, type) => {
    try {
      return Service.get(
        `finance/v1/document/transaction?id=${id}&type=${type}`,
        token
      );
    } catch (err) {
      throw err;
    }
  },

  // create new tax statement
  createNewTaxStatement: async (data, token) => {
    try {
      return await Service.post({
        url: `finance/v1/document/statement`,
        token,
        data,
      });
    } catch (error) {
      throw error;
    }
  },

  // create new tax statement
  createNewTaxReport: async (data, token) => {
    try {
      return await Service.post({
        url: `finance/v1/document/report`,
        token,
        data,
      });
    } catch (error) {
      throw error;
    }
  },

  // get all transactions
  getAllBatchLists: async (
    token,
    currentPage = 1,
    items_per_page = 10,
    body = null
  ) => {
    try {
      return await Service.post({
        url: `finance/v1/deposit/batchList?current_page=${currentPage}&items_per_page=${items_per_page}`,
        token,
        data: body,
      });
    } catch (error) {
      throw error;
    }
  },
  // get all deposit
  getAllDepositLists: async (
    token,
    currentPage = 1,
    items_per_page = 10,
    body = null
  ) => {
    try {
      return await Service.post({
        url: `finance/v1/deposit/depositList?current_page=${currentPage}&items_per_page=${items_per_page}`,
        token,
        data: body,
      });
    } catch (error) {
      throw error;
    }
  },
  // get list of batch billings
  getListofBatchBilling: async (
    token,
    currentPage = 1,
    items_per_page = 10,
    body = null
  ) => {
    try {
      return await Service.post({
        url: `finance/v1/batchBilling/list?current_page=${currentPage}&items_per_page=${items_per_page}`,
        token,
        data: body,
      });
    } catch (error) {
      throw error;
    }
  },

  // create New Batch
  creatNewbatch: async (token, body = null) => {
    try {
      return await Service.post({
        url: `finance/v1/deposit/batch`,
        token,
        data: body,
      });
    } catch (error) {
      throw error;
    }
  },

  // get list of batch billings
  getListofAccounts: async (
    token,
    currentPage = 1,
    items_per_page = 50,
    body = null
  ) => {
    try {
      return await Service.post({
        url: `accounts/account/batchBilling?current_page=${currentPage}&items_per_page=${items_per_page}`,
        token,
        data: body,
      });
    } catch (error) {
      throw error;
    }
  },
  // get list of account for previous amounts
  getListofPreviousAmountAccounts: async (
    token,
    currentPage = 1,
    items_per_page = 50,
    body = null
  ) => {
    try {
      return await Service.post({
        url: `finance/v1/transaction/accounts?current_page=${currentPage}&items_per_page=${items_per_page}`,
        token,
        data: body,
      });
    } catch (error) {
      throw error;
    }
  },
  //Add credit card
  addCreditCard: async (token, account_id, data) => {
    try {
      return await Service.post({
        url: `finance/v1/payment/card?accountId=${account_id}`,
        token,
        data,
      });
    } catch (error) {
      throw error;
    }
  },

  setDefaultCreditCard: async (data, token) => {
    try {
      return await Service.update({
        url: `finance/v1/payment/card`,
        data,
        token,
      });
    } catch (error) {
      throw error;
    }
  },

  //Add Account ACH
  addACHAccount: async (token, account_id, accountDetail) => {
    // console.log("ach data:", accountDetail);
    try {
      return await Service.post({
        url: `finance/v1/payment/ach?accountId=${account_id}`,
        token,
        data: {
          accountType: accountDetail?.type,
          routingNumber: accountDetail?.routing,
          accountNumber: accountDetail?.number,
          nameOnAccount: accountDetail?.name,
        },
      });
    } catch (error) {
      throw error;
    }
  },

  //Get list of ACH Account
  getACHCardsByAccountId: (token, accountId, providerId) => {
    try {
      return Service.get(
        `/finance/v1/payment/ach/list?accountId=${accountId}${providerId ? `&providerId=${providerId}` : ""
        }`,
        token
      );
    } catch (err) {
      throw err;
    }
  },

  setDefaultAch: async (data, token) => {
    try {
      return await Service.update({
        url: `finance/v1/payment/ach`,
        data,
        token,
      });
    } catch (error) {
      throw error;
    }
  },

  //Get list of credit cards
  getCreditCardsByAccountId: (
    token,
    accountId,
    limit = 10,
    providerId = ""
  ) => {
    try {
      return Service.get(
        `finance/v1/payment/card/list?accountId=${accountId}&limit=${limit}${providerId ? `&providerId=${providerId}` : ""
        }`,
        token
      );
    } catch (err) {
      throw err;
    }
  },
  getCreditOnAccountAmount: async (id, token) => {
    try {
      return await Service.get(`finance/v1/payment/balance?id=${id}`, token);
    } catch (error) {
      throw error;
    }
  },

  deleteCreditCard: (token, cardId, accountId) => {
    try {
      return Service.remove({
        url: "finance/v1/payment/card",
        data: {
          accountId,
          cardId,
        },
        token,
      });
    } catch (err) {
      throw err;
    }
  },

  deleteAchCard: (token, achId, accountId) => {
    try {
      return Service.remove({
        url: "finance/v1/payment/ach",
        data: {
          accountId,
          achId,
        },
        token,
      });
    } catch (err) {
      throw err;
    }
  },

  //Ledgeraccounts
  getLedgeraccounts: async (filter, token) => {
    try {
      return await Service.get(`/finance/ledger/${filter}`, token);
    } catch (error) {
      throw error;
    }
  },

  getLedgerAccountsForDonation: async (donation, token) => {
    try {
      return await Service.get(
        `setting/v1/finance/ledger/list?filter=${donation}`,
        token
      );
    } catch (error) {
      throw error;
    }
  },
  getLedgerSubLedgerList: async (token) => {
    try {
      return await Service.get(`/setting/v1/finance/ledger/list`, token);
    } catch (error) {
      throw error;
    }
  },

  getLedgerSubLedgerListAll: async (token) => {
    try {
      return await Service.get(
        `/setting/v1/finance/ledger/list?active=false`,
        token
      );
    } catch (error) {
      throw error;
    }
  },

  getAllLedgeraccounts: async (token) => {
    try {
      return await Service.post({ url: `/accounts/ledger/all`, token });
    } catch (error) {
      throw error;
    }
  },
  getSubLedgerAccount: async (token, id) => {
    try {
      return await Service.post({
        url: `/accounts/subLedger/ledger/${id}`,
        token,
      });
    } catch (error) {
      throw error;
    }
  },
  addLedgerAccount: async (data, token) => {
    try {
      return await Service.post({ url: "/finance/ledger", data, token });
    } catch (error) {
      throw error;
    }
  },
  updateLedgerAccount: async (data, token) => {
    try {
      return await Service.update({ url: `/finance/ledger/`, data, token });
    } catch (error) {
      throw error;
    }
  },
  //Subcategories

  getSubcategoriesByLedgerAccount: async (id, token) => {
    try {
      return await Service.get(`/finance/subcat/ledacc/${id}`, token);
    } catch (error) {
      throw error;
    }
  },
  getFilteredSubcaegories: async (filter, token) => {
    try {
      return await Service.get(`/finance/subcat/${filter}`, token);
    } catch (error) {
      throw error;
    }
  },
  getSubcategoriesByLedgerAccountFiltered: async (filter, id, token) => {
    try {
      return await Service.get(`/finance/subcat/ledacc/${id}${filter}`, token);
    } catch (error) {
      throw error;
    }
  },
  addSubcategorie: async (data, token) => {
    try {
      return await Service.post({ url: "/finance/subcat", data, token });
    } catch (error) {
      throw error;
    }
  },
  removeSubcateggorie: async (data, token) => {
    try {
      return await Service.remove({ url: `/finance/subcat/`, data, token });
    } catch (error) {
      throw error;
    }
  },
  updateSubcategorie: async (data, token) => {
    try {
      return await Service.update({ url: `/finance/subcat/`, data, token });
    } catch (error) {
      throw error;
    }
  },

  //PRODUCTS
  getAllProducts: async (token) => {
    try {
      return await Service.get(`/finance/prod`, token);
    } catch (error) {
      throw error;
    }
  },
  getFilteredProducts: async (filter, token) => {
    try {
      return await Service.get(`/finance/prod/${filter}`, token);
    } catch (error) {
      throw error;
    }
  },
  getProductsByLedgerAccount: async (filter, id, token) => {
    try {
      return await Service.get(`/finance/prod/ledger/${id}${filter}`, token);
    } catch (error) {
      throw error;
    }
  },
  getProductsBySubCat: async (filter, id, token) => {
    try {
      return await Service.get(`/finance/prod/subcat/${id}${filter}`, token);
    } catch (error) {
      throw error;
    }
  },
  removeProduct: async (data, token) => {
    try {
      return await Service.remove({ url: `/finance/prod/`, data, token });
    } catch (error) {
      throw error;
    }
  },
  addProduct: async (data, token) => {
    try {
      return await Service.post({ url: `/finance/prod/`, data, token });
    } catch (error) {
      throw error;
    }
  },
  updateProduct: async (data, token) => {
    try {
      return await Service.update({ url: `/finance/prod/`, data, token });
    } catch (error) {
      throw error;
    }
  },
  // payment requests
  getPaymentRequests: async (filter, page, size, token) => {
    try {
      return await Service.get(
        `/finance/paymentreq${filter}&page=${page + 1}&size=${size}`,
        token
      );
    } catch (error) {
      throw error;
    }
  },

  getInvoicesByMemberId: async (data, token) => {
    try {
      return await Service.post({
        url: `/finance/invoice/filter`,
        data,
        token,
      });
    } catch (error) {
      throw error;
    }
  },
  getFilteredInvoices: async (page, size, token) => {
    try {
      return await Service.get(
        `/finance/invoice/filter?page=${page}&size=${size}`,
        token
      );
    } catch (error) {
      throw error;
    }
  },

  getInvoices: async (data, page, size, token) => {
    try {
      return await Service.post({
        url: `/finance/invoice/filter?page=${page + 1}&size=${size}`,
        data,
        token,
      });
    } catch (error) {
      throw error;
    }
  },
  getProducts: async (token, search) => {
    try {
      return await Service.get(
        `/finance/prod/search${search ? `?search=${search}` : ""}`,
        token
      );
    } catch (error) {
      throw error;
    }
  },
  getInvoicesById: async (token, id) => {
    try {
      return await Service.get(`/finance/invoice/${id}`, token);
    } catch (error) {
      throw error;
    }
  },

  getFilterdPaymentRequests: async (data, token) => {
    try {
      return await Service.post({
        url: `/finance/paymentreq?page=1&size=10000`,
        data,
        token,
      });
    } catch (error) {
      throw error;
    }
  },

  //get payment methods
  getPaymentMethods: (token) => {
    try {
      return Service.get(`/setting/v1/finance/payment`, token);
    } catch (error) {
      throw error;
    }
  },

  //cards
  getCardsById: async (id, token) => {
    try {
      return await Service.get(`/finance/billing/cards?account=${id}`, token);
    } catch (error) {
      throw error;
    }
  },
  pay: async (data, token) => {
    try {
      return await Service.post({ url: `/finance/billing/pay`, data, token });
    } catch (error) {
      throw error;
    }
  },

  RecurringPayment: (data, token) => {
    return Service.post({
      url: "finance/v1/payment/recurring",
      data,
      token,
    });
  },

  checkout: (data, token) => {
    return Service.post({
      url: "finance/v1/payment/checkout",
      data,
      token,
    });
  },
  reverseCharge: (id, token) => {
    return Service.update({
      url: `finance/v1/transaction/reverse`,
      data: id,
      token,
    });
  },

  // PaymentInfoAction
  PaymentInfoAction: (value, token) => {
    return Service.update({
      url: `finance/v1/payment/recurring`,
      data: value,
      token,
    });
  },

  getAllReversalTypes: async (type, token) => {
    try {
      return await Service.get(
        `/setting/v1/finance/reversal?type=${type}`,
        token
      );
    } catch (error) {
      throw error;
    }
  },
  createNewUserAccount: async (data, token) => {
    try {
      return await Service.post({
        url: `accounts/account/mainmember`,
        data,
        token,
      });
    } catch (error) {
      throw error;
    }
  },
  ViewBatchPayment: async (
    token,
    currentPage = 1,
    items_per_page = 10,
    body = null
  ) => {
    try {
      return await Service.post({
        url: `finance/v1/transaction/all?current_page=${currentPage}&items_per_page=${items_per_page}`,
        data: body,
        token,
      });
    } catch (error) {
      throw error;
    }
  },
  addBatchPayment: async (body, token) => {
    try {
      return await Service.post({
        url: `finance/v1/batchBilling`,
        data: body,
        token,
      });
    } catch (error) {
      throw error;
    }
  },

  addBatchPaymentFile: async (body, token) => {
    console.log("body:", body);
    try {
      return await Service.post({
        url: `finance/v1/batchBilling/upload/charges`,
        data: body,
        token,
      });
    } catch (error) {
      throw error;
    }
  },

  editBatchPayment: async (id, body, token) => {
    try {
      return Service.update({
        url: `finance/v1/batchBilling/${id}`,
        data: body,
        token,
      });
    } catch (error) {
      throw error;
    }
  },
  editBatchBillingById: async (id, token) => {
    try {
      return Service.get(`finance/v1/batchBilling/${id}`, token);
    } catch (error) {
      throw error;
    }
  },
  completeBatchPayment: async (id, token) => {
    try {
      return await Service.update({
        url: `/finance/v1/batchBilling/complete/${id}`,
        data: {},
        token,
      });
    } catch (error) {
      throw error;
    }
  },
  cloneBatchPayment: async (id, token) => {
    try {
      return await Service.get(`finance/v1/batchBilling/clone/${id}`, token);
    } catch (error) {
      throw error;
    }
  },
  pauseBatchPayment: async (id, token) => {
    try {
      return await Service.update({
        url: `/finance/v1/batchBilling/pause/${id}`,
        data: {},
        token,
      });
    } catch (error) {
      throw error;
    }
  },
  deleteBatchPayment: async (id, token) => {
    try {
      return await Service.remove({
        url: `finance/v1/batchBilling/${id}`,
        token,
      });
    } catch (error) {
      throw error;
    }
  },
  Unbatch: async (id, token) => {
    try {
      return await Service.update({
        url: `finance/v1/deposit/unbatch/${id}`,
        data: {},
        token,
      });
    } catch (error) {
      throw error;
    }
  },
  markAsBatchedSynced: async (id, token) => {
    try {
      return await Service.post({
        url: `finance/v1/deposit/batch/sync`,
        data: {
          batchId: id,
        },
        token,
      });
    } catch (error) {
      throw error;
    }
  },
  Undeposit: async (id, token) => {
    try {
      return await Service.update({
        url: `finance/v1/deposit/undeposit/${id}`,
        data: {},
        token,
      });
    } catch (error) {
      throw error;
    }
  },
  getDataFilterForEditById: async (id, token) => {
    try {
      return await Service.get(`/accounts/filter/${id}`, token);
    } catch (error) {
      throw error;
    }
  },
  getDepositDetails: async (id, token) => {
    try {
      return await Service.get(`/finance/v1/deposit/details/${id}`, token);
    } catch (error) {
      throw error;
    }
  },
  getBulkPayments: async (
    token,
    currentPage = 1,
    items_per_page = 10,
    body = null
  ) => {
    try {
      return await Service.post({
        url: `/finance/v1/payment/bulk-payment?current_page=${currentPage}&items_per_page=${items_per_page}`,
        data: body,
        token,
      });
    } catch (error) {
      throw error;
    }
  },
  getBulkPaymentsById: async (id, token) => {
    try {
      return await Service.get(
        `/finance/v1/payment/bulk-payment?id=${id}`,
        token
      );
    } catch (error) {
      throw error;
    }
  },
  getBulkPaymentPayments: async (id, token) => {
    try {
      return await Service.get(
        `/finance/v1/payment/bulk-payment/payments?id=${id}`,
        token
      );
    } catch (error) {
      throw error;
    }
  },
  // without page count
  getBulkPaymentData: async (
    token,
    currentPage = 1,
    items_per_page = 10,
    body = null
  ) => {
    try {
      return await Service.post({
        url: `/finance/v1/payment/allData?current_page=${currentPage}&items_per_page=${items_per_page}`,
        data: body,
        token,
      });
    } catch (error) {
      throw error;
    }
  },
  // get export payment transactions enhancement
  getExportBulkPaymentData: async (token, body = null) => {
    try {
      return await Service.post({
        url: `/finance/v1/payment/export`,
        data: body,
        token,
      });
    } catch (error) {
      throw error;
    }
  },
  getBulkPaymentCount: async (
    token,
    currentPage = 1,
    items_per_page = 10,
    body = null
  ) => {
    try {
      return await Service.post({
        url: `/finance/v1/payment/allCount?current_page=${currentPage}&items_per_page=${items_per_page}`,
        data: body,
        token,
      });
    } catch (error) {
      throw error;
    }
  },

  // Send document share
  sendDocumentShare: async (token, data) => {
    try {
      return await Service.post({
        url: `/finance/v1/document/share`,
        data,
        token,
      });
    } catch (error) {
      throw error;
    }
  },
  // Send document bulk share
  sendDocumentBulkShare: async (token, data) => {
    try {
      return await Service.post({
        url: `/finance/v1/document/bulk-share`,
        data,
        token,
      });
    } catch (error) {
      throw error;
    }
  },

  // Download document
  downloadDocument: async (token, documentId) => {
    try {
      return await axios({
        method: "get",
        url: `${process.env.REACT_APP_BASE_URL}/finance/v1/document/download?id=${documentId}`,
        responseType: "blob",
        headers: {
          Accept: "application/pdf",
          Authorization: `Bearer ${token}`,
          "Access-Control-Expose-Headers": "Content-Disposition",
        },
      });
    } catch (error) {
      throw error;
    }
  },

  // view documents
  viewDocument: async (token, documentId) => {
    try {
      return await Service.get(
        `/finance/v1/document/view/?id=${documentId}`,
        token
      );
    } catch (error) {
      throw error;
    }
  },

  // delete document
  deleteDocument: async (token, documentId) => {
    try {
      return await Service.remove({
        url: `/finance/v1/document/${documentId}`,
        token,
      });
    } catch (error) {
      throw error;
    }
  },

  // download documents
  downloadDocuments: async (token, data) => {
    try {
      return await Service.post({
        url: `/finance/v1/document/download`,
        data,
        token,
      });
    } catch (error) {
      throw error;
    }
  },
  sendSharePaymentLink: async (token, data) => {
    try {
      return await Service.post({
        url: `/finance/v1/transaction/payment-link`,
        data,
        token,
      });
    } catch (error) {
      throw error;
    }
  },
  MergeAccount: async (data, token) => {
    try {
      return await Service.post({
        url: `/finance/v1/transaction/merge-account`,
        data: data,
        token,
      });
    } catch (error) {
      throw error;
    }
  },
  // get document donation letter by transaction id
  getDonationLetterByTransactionId: async (token, data) => {
    try {
      return await Service.post({
        url: `finance/v1/document/donation`,
        data,
        token,
      });
    } catch (err) {
      throw err;
    }
  },
  // download document donation letter by transaction id
  downloadDonationLetterByTransactionId: async (token, data) => {
    try {
      return await axios({
        method: "post",
        url: `${process.env.REACT_APP_BASE_URL}/finance/v1/document/donation`,
        responseType: "blob",
        headers: {
          Accept: "application/pdf",
          Authorization: `Bearer ${token}`,
          "Access-Control-Expose-Headers": "Content-Disposition",
        },
        data,
      });
    } catch (error) {
      throw error;
    }
  },
  cancelInstallment: async (token, data) => {
    try {
      return await Service.update({
        url: `finance/v1/payment/cancel-installment`,
        data,
        token,
      });
    } catch (error) {
      throw error;
    }
  },
  // Get recurring info
  getRecurringInfo: async ({ token, id, installment }) => {
    try {
      return await Service.get(
        `/finance/v1/payment/recurring?id=${id}&installment=${installment}`,
        token
      );
    } catch (error) {
      throw error;
    }
  },

  // Replace payment info
  ReplacePaymentInfo: async ({ token, data }) => {
    try {
      return await Service.update({
        url: `finance/v1/payment/replace/info`,
        data,
        token,
      });
    } catch (error) {
      throw error;
    }
  },
  checkConnectedPaymentMethod: async ({ token, accountId, id }) => {
    try {
      return await Service.get(
        `/finance/v1/payment/check/method?accountId=${accountId}&providerId=${id}`,
        token
      );
    } catch (error) {
      throw error;
    }
  },
  createNewSageDeposit: async (data, token) => {
    try {
      const response = await axiosDefault.post(
        `${process.env.REACT_APP_BASE_URL}/finance/v1/deposit/synce`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          responseType: "blob", // Ensure response is treated as a file
        }
      );
      return response;
    } catch (error) {
      throw error;
    }
  },
  getAccountByID: async (token, id) => {
    try {
      return await Service.get(
        `/accounts/contact?page=${1}&size=${30}&member=all&account=${id}`,
        token
      );
    } catch (error) {
      throw error;
    }
  },
  mergeContact: async (token, data) => {
    try {
      return await Service.post({
        url: "/finance/v1/transaction/merge-contacts",
        data,
        token,
      });
    } catch (error) {
      throw error;
    }
  },
  updatePaymentMethod: async (token, data) => {
    try {
      return await Service.post({
        url: `/finance/v1/payment/update-method`,
        data,
        token,
      });
    } catch (error) {
      throw error;
    }
  },

  checkStripeSetup: async (token, accountId) => {
    // const accountId = localStorage.getItem("accountID");
    try {

      return await Service.post({
        url: `finance/v1/payment/intent?accountId=${accountId}`,
        token,
      });
    } catch (error) {
      throw error;
    }
  },

  tranzilaHandshake: async (token, data) => {
    try {
      return await Service.post({
        url: `finance/v1/payment/tranzila/handshake`,
        token,
        data,
      });
    } catch (error) {
      throw error;
    }
  },

  tranzilaIframePoll: async (token, thtk) => {
    try {
      return await Service.get(`finance/v1/payment/tranzila/poll/${thtk}`, token);
    } catch (error) {
      throw error;
    }
  },

  addACHAccountStripe: async (token, account_id, accountDetail) => {
    try {
      return await Service.post({
        url: `finance/v1/payment/ach?accountId=${account_id}`,
        token,
        data: {
          achData: accountDetail || {}
        },
      });
    } catch (error) {
      throw error;
    }
  },
  getAllRecurring: async (token, currentPage = 1, itemsPerPage = 30, body = {}) => {
    try {
      return await Service.post({
        url: `finance/v1/recurring/all?current_page=${currentPage}&items_per_page=${itemsPerPage}`,
        token,
        data: body,
      });
    } catch (error) {
      throw error;
    }
  },
  exportAllRecurring: async (token, body = {}) => {
    try {
      return await Service.post({
        url: `finance/v1/recurring/all/export`,
        token,
        data: body,
      });
    } catch (error) {
      throw error;
    }
  },
};
export default FinanceService;